import DropdownNavbarPC from '@/User/Components/Header/DropdownNavbarPC';
import HeaderButton from '@/User/Components/Header/HeaderButton';
import { RouteName } from '@/User/Constants/routes';
import { TYPE_COMPANY } from "@/User/Constants/user";
import { useTwilioClientContext } from '@/User/Contexts/TwilioClientContext';
import { router, usePage } from '@inertiajs/react';
import axios from 'axios';
import { truncate } from "lodash";
import React from "react";
import route from "ziggy-js";

const MenuPC = ({
    headerMenu = {},
    className = "",
    handleMouseEnterMenu = () => {},
    handleMouseLeaveMenu = () => {},
}) => {
    const { auth: { user } } = usePage().props;
    const { unreadCount, resetTwilioClient } = useTwilioClientContext();

    const handleLogout = async () => {
        axios.post(route(RouteName.LogoutPage))
            .then(async () => {
                await resetTwilioClient();
                router.visit(route(RouteName.LoginPage));
            });

    };

    return (
        <ul className={className}>
            <li className="relative inline-flex flex-col justify-center text-right mr-4">
                {user?.data?.type == TYPE_COMPANY && <p>株式会社 {truncate(user?.data?.company_name, { length: 23 })}</p>}
                <p>{truncate(user?.data?.full_name, { length: 25 })} 様</p>
            </li>
            <li className="relative" key={headerMenu.Favorite.name}>
                <HeaderButton
                    className="w-20 h-20"
                    labelText={headerMenu.Favorite.labelText}
                    srcIcon={headerMenu.Favorite.srcIcon}
                    onClick={headerMenu.Favorite.onClick}
                />
            </li>
            {
                Object.values(headerMenu).map((item) => (
                    item.show && <li className="relative"
                        key={item.name}
                        onMouseEnter={item.options && handleMouseEnterMenu(item.name)}
                        onMouseLeave={item.options && handleMouseLeaveMenu(item.name)}
                    >
                        <HeaderButton className="min-w-20 h-20 px-1" labelText={item.labelText} srcIcon={item.srcIcon} icon={item.iconPC} onClick={item.onClick ?? null} />
                        {item.name === "Mail" &&
                        unreadCount.all > 0 && (
                            <span
                                className="absolute rounded-full min-w-3.5 h-3.5 px-0.5 leading-3.5 bg-free-speech-red text-3xs font-semibold text-white top-3.5 right-5 flex items-center justify-center"
                            >
                                {unreadCount.all}
                            </span>
                        )}
                        {item.options && <DropdownNavbarPC isActive={item.isActive} options={item.options} afterClick={handleMouseLeaveMenu(item.name)} />}
                    </li>
                ))
            }
            <li className="relative" key={headerMenu.Logout.name}>
                <HeaderButton
                    className="w-20 h-20"
                    labelText={headerMenu.Logout.labelText}
                    srcIcon={headerMenu.Logout.srcIcon}
                    onClick={() => handleLogout()}
                />
            </li>
        </ul>
    );
};

export default MenuPC;
